import React, { Fragment, useContext } from 'react'
import { BrowserRouter as Router, Link, useRouteMatch } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import AssessmentIcon from '@material-ui/icons/Assessment'
import DeleteIcon from '@material-ui/icons/Delete'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import IconButton from '@material-ui/core/IconButton'
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye'
import { ContextReports } from 'src/context/ContextReports'
import { Context } from 'src/context/Contex'
import { minPermisos, permitsList } from 'src/constants'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))

export default function AccordionMenu({ menu }) {
  const classes = useStyles()
  const { permisos } = useContext(Context)
  const [expanded, setExpanded] = React.useState(false)
  const { setUrlReport, setPrevFile } = useContext(ContextReports)
  const minValue = permisos[permitsList.BOARD_REPORTS]

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }

  const { path } = useRouteMatch()

  const expand = menu.map(value => value.title === expanded)

  return (
    <>
      {menu.map((value) => (
          <Fragment key={value.title}>
            <List
              expanded={expand}
              onChange={handleChange(value.title)}
            >
              <ListItemText primary={value.title} />
              {Array.isArray(value.nodo) && (
                <List className={classes.root}>
                  {value.nodo.map((item) => (
                      <React.Fragment key={item.title}>
                        <ListItem
                          component={item.download ? 'span' : Link}
                          to={`${path}${item.path}`}
                        >
                          <ListItemIcon>
                            <AssessmentIcon />
                          </ListItemIcon>
                          <ListItemText primary={item.title} />
                          {item.download ? (
                            <ListItemSecondaryAction>
                              <IconButton
                                edge="end"
                                aria-label="upload"
                                onClick={() => setUrlReport({ ...item })}
                              >
                                <CloudUploadIcon />
                              </IconButton>
                              {minValue >= minPermisos.ACTUALIZAR && (
                                <>
                                  <IconButton
                                    edge="end"
                                    aria-label="see"
                                    onClick={() =>
                                      setPrevFile({ ...item, openP: true })
                                    }
                                  >
                                    <RemoveRedEyeIcon />
                                  </IconButton>
                                </>
                              )}
                              {minValue >= minPermisos.ELIMINAR && (
                                <>
                                  <IconButton
                                    edge="end"
                                    aria-label="see"
                                    onClick={() =>
                                      setPrevFile({ ...item, delete: true })
                                    }
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </>
                              )}
                            </ListItemSecondaryAction>
                          ) : null}
                        </ListItem>
                      </ React.Fragment>
                    ))}
                </List>
              )}
            </List>
          </Fragment>
        ))}
    </>
  )
}
